<template>
  
  <div v-if="showPdfLoader" class="abs d-flex flex-column align-center justify-center">
    <v-overlay>
    <div class="text-center">
        {{ localStorage.translations.pages.common.breadcrumbs.loading }}
    </div>
    <div v-for="(item, i) in pdfLoader" :key="item.id" class="d-grid grid-col-auto-1 align-center gap-5 my-6">
      <div> {{ localStorage.translations.pages.common.text['file_number'] }} {{ i + 1 }} </div>
      <div>
        <v-progress-circular
         :size="60"
         :width="10"
         :value="Number(item.created ? 10 : 0) + Number(item.pages ? (item.pageLoaded * 90) / item.pages : 0)"
         color="primary"
        />
      </div>
    </div>
  </v-overlay>
  </div>
  
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'pdfLoader',
  computed: {
    ...mapGetters(['pdfLoader', 'showPdfLoader']),
  },
}
</script>

<style scoped lang="scss">
.abs {
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 200;
}

:deep() .v-progress-circular__underlay {
  stroke: var(--v-secondary-lighten1) !important;
}
</style>